import React, { useState, useRef, useEffect } from 'react';
import clientService from 'services/http/client-service';
import { CustomButton, Input, ToastNotification, DropdownTemplate, WithLoadingComponent, SkeletonLoader } from 'components/shared';
import utils, { CUSTOM_MESSAGES } from 'utils';
import { useHistory } from 'react-router';


export const ClientEditionForm = (props) => {

    const [clientBody, setClientBody] = useState(props.client);
    const [patchLoading, setPatchLoading] = useState();
    const toastRef = useRef();
    const history = useHistory();

    useEffect(() => {
        utils.fixContainersOverlaping();
    }, []);

    const submitEditForm = (e) => {
        e.preventDefault();
        if (clientBody === props.client) {
            toastRef.current?.showToast({ type: "info", title: "Client info edit", message: CUSTOM_MESSAGES.NO_CHANGES_ISSUED, durable: true });
        } else {
            setPatchLoading(true);
            clientService.updateClient(clientBody).then((response) => {
                toastRef.current?.showToast({ type: "success", title: response.message });
                setTimeout(() => {
                    props.onEditCallback(response.result);
                    updateTaskNestedClientInfo(response.result);
                }, 1000);
            }, error => {
                toastRef.current?.showToast({ type: "warn", title: "Error response", message: error, durable: true });
            }).finally(() => {
                setPatchLoading(false);
            });
        }
    }

    //UPDATE CLIENT NESTED OBJECT IN CURRENT TASK FROM URL SEARCH PARAM
    const updateTaskNestedClientInfo = (client) => {
        let updateTask = JSON.parse(new URLSearchParams(window.location.search).get("task"));
        updateTask['client'] = client;
        utils.pushURLSearchParams(history, "task", JSON.stringify(updateTask));
    }


    return (
        <div>
            <form className="mr-2" onSubmit={submitEditForm}>
                <InputFormTepmlate label="FIRSTNAME">
                    <Input
                        placeholder="Firstame"
                        type="text"
                        value={clientBody.firstname}
                        onChange={(e) => { setClientBody({ ...clientBody, firstname: e.target.value }) }}
                    />
                </InputFormTepmlate>

                <InputFormTepmlate label="LASTNAME">
                    <Input
                        placeholder="Lastname"
                        type="text"
                        value={clientBody.lastname}
                        onChange={(e) => { setClientBody({ ...clientBody, lastname: e.target.value }) }}
                    />
                </InputFormTepmlate>

                <InputFormTepmlate label="EMAIL">
                    <Input
                        placeholder="Email"
                        type="email"
                        value={clientBody.email}
                        onChange={(e) => { setClientBody({ ...clientBody, email: e.target.value }) }}
                    />
                </InputFormTepmlate>

                <InputFormTepmlate label="PHONE Ooredoo 1">
                    <Input
                        placeholder="Phone Ooredoo 1"
                        type="number"
                        value={clientBody.phoneNumber}
                        onChange={(e) => { setClientBody({ ...clientBody, phoneNumber: e.target.value }) }}
                    />
                </InputFormTepmlate>

                <InputFormTepmlate label="PHONE Ooredoo 2">
                    <Input
                        placeholder="Phone Ooredoo 2"
                        type="number"
                        value={clientBody.phoneNumber2}
                        onChange={(e) => { setClientBody({ ...clientBody, phoneNumber2: e.target.value }) }}
                    />
                </InputFormTepmlate>

                <InputFormTepmlate label="N° Contrat BSCS">
                    <Input
                        placeholder="N° Contrat BSCS"
                        value={clientBody.bscsContract}
                        onChange={(e) => { setClientBody({ ...clientBody, bscsContract: e.target.value }) }}
                    />
                </InputFormTepmlate>

                <InputFormTepmlate label="GPS Coordinates">
                    <Input
                        placeholder="GPS Coordinates"
                        value={clientBody.gps}
                        onChange={(e) => { setClientBody({ ...clientBody, gps: e.target.value }) }}
                    />
                </InputFormTepmlate>

                <InputFormTepmlate label="Wilaya">
                    <WilayaDropdownHoc value={clientBody.wilaya} callbackFn={(payload) => { setClientBody({ ...clientBody, wilaya: payload }) }} />
                </InputFormTepmlate>

                <InputFormTepmlate label="Commune">
                    <CommuneDropdownHoc value={clientBody.commune} wilaya={clientBody.wilaya} callbackFn={(payload) => { setClientBody({ ...clientBody, commune: payload }) }} />
                </InputFormTepmlate>

                <InputFormTepmlate label="ADDRESS">
                    <Input
                        placeholder="Address"
                        type="text"
                        value={clientBody.adress}
                        onChange={(e) => { setClientBody({ ...clientBody, adress: e.target.value }) }}
                    />
                </InputFormTepmlate>

                <InputFormTepmlate label="DATE OF BIRTH">
                    <Input
                        placeholder="Date of birth"
                        type="date"
                        value={clientBody.birthday ? new Date(clientBody.birthday).toISOString().split('T')[0] : null}
                        onChange={(e) => { setClientBody({ ...clientBody, birthday: new Date(e.target.value).getTime() }) }}
                    />
                </InputFormTepmlate>

                <InputFormTepmlate label="Comment">
                    <Input
                        placeholder="Comment"
                        type="text"
                        value={clientBody.comments}
                        onChange={(e) => { setClientBody({ ...clientBody, comments: e.target.value }) }}
                    />
                </InputFormTepmlate>

                <div className="my-2 w-100 text-right">
                    <CustomButton
                        label={<><i className="bi bi-x-circle" />  CANCEL</>}
                        style={{ width: "30%" }}
                        className="p-button-warning"
                        onClick={(e) => { props.dismissEditForm() }} />&nbsp;
                    <CustomButton
                        label={utils.labelTemplate(<><i className="bi bi-check-circle" /> SAVE</>, patchLoading, "Processing...")}
                        type="submit"
                        className={patchLoading && "not-allowed"}
                        style={{ width: "40%" }}
                    />
                </div>
            </form>
            <ToastNotification ref={toastRef} />
        </div>
    );
}

//INPUT FORM TEMPLATE
export const InputFormTepmlate = (props) => {
    return (
        <div className="d-flex justify-content-between py-1">
            <small>{props.label}</small>
            <div style={{ width: "70%" }}>
                {props.children}
            </div>
        </div>
    );
}

//WILAYAS DROPDOWN TEMPLATE COMPONENT
const WilayaDropdownTemplate = (props) => {

    const [selectedItem, setSelectedItem] = useState(props.value?.wilayaId);
    const wilayas = props.data.map((item) => { item["value"] = `${item.wilayaId} - ${item.wilayaName}`; return item; })

    return <DropdownTemplate
        placeholder="Wilaya"
        options={wilayas}
        selectedItem={selectedItem}
        optionLabel={"value"}
        optionValue={"wilayaId"}
        className="sm-dropdown"
        icon={props.icon}
        scrollHeight={150}
        style={{ width: '100%' }}
        onFocus={props.onFocus}
        onBlur={props.onBlur}
        onItemChange={(e) => {
            setSelectedItem(e.value);
            props.callbackFn(wilayas.find(item => item.wilayaId === e.value));
        }} />
}

//WILAYAS COMPONENT WITH HOC PATTERN
export const WilayaDropdownHoc = ((props) => {
    const WilayasHoc = React.useMemo(() => WithLoadingComponent(WilayaDropdownTemplate, () => clientService.getWilayas(), <SkeletonLoader rectangle factor={1} />)(props));
    return <WilayasHoc />;
});

//COMMUNES DROPDOWN TEMPLATE COMPONENT
const CommuneDropdownTemplate = (props) => {

    const [selectedItem, setSelectedItem] = useState(props.value?.communeId);
    const communes = props.data.map((item) => { item["value"] = item.communeName; return item; })

    return <DropdownTemplate
        placeholder="Commune"
        options={communes}
        selectedItem={selectedItem}
        optionLabel="communeName"
        optionValue="communeId"
        className="sm-dropdown"
        scrollHeight={150}
        style={{ width: '100%' }}
        onItemChange={(e) => {
            setSelectedItem(e.value);
            props.callbackFn(communes.find(item => item.communeId === e.value));
        }} />

}

//COMMUNES COMPONENT WITH HOC PATTERN
export const CommuneDropdownHoc = ((props) => {
    const { wilaya } = props;
    const CommunesHoc = React.useMemo(() => WithLoadingComponent(CommuneDropdownTemplate, () => clientService.getCommunes(wilaya?.wilayaId), <SkeletonLoader rectangle factor={1} />)(props), [wilaya]);
    return <CommunesHoc />;
});